import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import _isEmpty from 'lodash/isEmpty';

import './main.less';
import sortByNumber from '../../../shared/sortByNumber';

const propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func
};

const Table = ({ columns, intl, data, columnGroups, toggleSort, sort }) => {

	return (
		<div className="table-container table-container--projector productivity-wrap">
			<div className="productivity-table">
				<table className="simple-table simple-table--static productivity-wrap__table">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							{Object.keys(columnGroups).map((col, i) => (
								<th key={i} className="productivity-col" colSpan={columnGroups[col].length}> {intl(col)} </th>
							))}
						</tr>
						<tr>
							{columns.map((header, i) => (
								<th
									key={i}
									className={cn({
										[header.className]: header.className,
										'sort-header': true,
										[sort[header.index]]: !!sort[header.index],
										'active': !!sort[header.index],
										'productivity-col': true
									})}
									onClick={toggleSort.bind(null, header)}
								>
									{intl(header.title)}
								</th>
							))}
						</tr>
					</thead>
					<tbody className="simple-table__body">{TableBody(data, columns, sort)}</tbody>
				</table>
			</div>
		</div>
	);
};

const TableBody = (rows, columns, sort) => {
	const rowsSorted = !_isEmpty(sort) ? sortByNumber(rows, ...Object.entries(sort)[0]) : rows;

	return rowsSorted.map((row, index) => {
		if (row.isTotal) {
			return <TotalRow key={index} columns={columns} row={row} />;
		}
		return <IndividualRow key={index} row={row} columns={columns}/>;
	});
};

const IndividualRow = props =>
	<tr className={`productivity-row ${props.row.isBeforeTotal ? 'is_total' : ''}`}>
		{props.columns.map((header, i) => (
			<td key={i} className="productivity-col">
				{Number(props.row[header.index]) ? Math.round(Number(props.row[header.index])): props.row[header.index] }
			</td>
		))}
	</tr>;

const TotalRow = props => {
	const overallRate = Number(props.row.real_approve_fulfilment) * 0.45
		+ Number(props.row.profit_fulfilment) * 0.45
		+ Number(props.row.active_affiliates_fulfilment) * 0.1;

	let approveBonus = 0;
	if (Number(props.row.real_approve_fulfilment) >= 85 && Number(props.row.real_approve_fulfilment) <= 95) {
		approveBonus = 350;
	}
	if (Number(props.row.real_approve_fulfilment) >= 96 && Number(props.row.real_approve_fulfilment) <= 105) {
		approveBonus = 450;
	}
	if (Number(props.row.real_approve_fulfilment) >= 106) {
		approveBonus = 650;
	}
	let profitBonus = 0;
	if (Number(props.row.profit_fulfilment) >= 85 && Number(props.row.profit_fulfilment) <= 95) {
		profitBonus = 350;
	}
	if (Number(props.row.profit_fulfilment) >= 96 && Number(props.row.profit_fulfilment) <= 105) {
		profitBonus = 450;
	}
	if (Number(props.row.profit_fulfilment) >= 106) {
		profitBonus = 650;
	}
	let affiliatesBonus = 0;

	if (Number(props.row.active_affiliates_fulfilment) >= 90 && Number(props.row.active_affiliates_fulfilment) <= 95) {
		affiliatesBonus = 100;
	}
	if (Number(props.row.active_affiliates_fulfilment) >= 96 && Number(props.row.active_affiliates_fulfilment) <= 100) {
		affiliatesBonus = 150;
	}
	if (Number(props.row.active_affiliates_fulfilment) >= 101) {
		affiliatesBonus = 200;
	}
	let toalCoef = overallRate/100;
	if (overallRate >= 106) {
		toalCoef = 1.2;
	}

	if (overallRate <= 105 && overallRate > 85) {
		toalCoef = 1;
	}

	return (
		<tr className="productivity-row is_total">
			<td className="productivity-col" colSpan={props.columns.length}>
				<div className="display-flex">
					<p className="margin-0-10">Взвешенный коэффициент {Math.floor(overallRate)}%</p>
					<p className="margin-0-10">Бонус за аппрув {approveBonus}$</p>
					<p className="margin-0-10">Бонус за маржу {profitBonus}$</p>
					<p className="margin-0-10">Бонус за активных вебов {affiliatesBonus}$</p>
					<p className="margin-0-10">
						Общий бонус с учетом коэфициэнта
						{` ${Math.round(toalCoef * 1000)/1000}`} =
						{Math.round((affiliatesBonus + approveBonus + profitBonus) * toalCoef * 100)/100}$
					</p>
				</div>
			</td>
		</tr>
	);
};

Table.propTypes = propTypes;
export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliate-managers-productivity/components/table/main.js